import { validateCPR } from './dk/cprValidator'
import dkValidatePhoneNumber from './dk/phoneNumberValidator'

import { validateSpanishNationalIdentificationNumber } from './es/nationaldentificationNumberValidator'
import validateFinnishNationalIdentificationNumber from './fi/nationalIdentificationNumberValidator'
import validateNorwegianNationalIdentificationNumber from './no/nationalIdentificationNumberValidator'
import validateSwedishNationalIdentificationNumber from './se/nationalIdentificationNumberValidator'
import validateDutchhNationalIdentificationNumber from './nl/nationalIdentificationNumberValidator'

import defaultCprValidator from './default/cprValidator'
import defaultValidatePhoneNumber from './default/phoneNumberValidator'

import { RegionalPersonalInformationValidator } from './types'

export const createPersonalInformationValidator = (
	regionId: string,
): RegionalPersonalInformationValidator => {
	switch (regionId) {
		case 'dk':
			return {
				validateCpr: validateCPR,
				validatePhoneNumber: dkValidatePhoneNumber,
			}
		case 'se':
			return {
				validateCpr: validateSwedishNationalIdentificationNumber,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
		case 'no':
			return {
				validateCpr: validateNorwegianNationalIdentificationNumber,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
		case 'fi':
			return {
				validateCpr: validateFinnishNationalIdentificationNumber,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
		case 'es':
			return {
				validateCpr: validateSpanishNationalIdentificationNumber,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
		case 'nl': 
			return {
				validateCpr: validateDutchhNationalIdentificationNumber,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
		default:
			return {
				validateCpr: defaultCprValidator,
				validatePhoneNumber: defaultValidatePhoneNumber,
			}
	}
}

